export const getDeviation = (actual, consensus) => {
    var result = "-";

    if (consensus && actual && consensus === actual) {
        result = 0;
    }

    return result;
}
